import { useAuth0 } from "@auth0/auth0-react";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";

import { constantsData, identifiersData, namesData, statusTypesData, urlsData } from "@/data";
import { useApisClient } from "@/hooks";
import { openAlert, setRefetchDriveManagementList } from "@/redux/actions";
import { displayErrorHandler } from "@/utils";

const useTrashDriveManagementFolder = () => {
    const [loading, setLoading] = useState(false);

    const { t } = useTranslation();

    const dispatch = useDispatch();

    const { logout } = useAuth0();

    const { patch: patchApi } = useApisClient();

    const { trashDriveManagementFolderPending: trashDriveManagementFolderPendingToastName } = namesData.toasts;

    const { toast: toastId } = identifiersData.ids;

    const trashDriveManagementFolder = (folderId) => {
        setLoading(true);

        patchApi(urlsData.apis.driveManagement.files.url, folderId, { trashed: true })
            .then(() => {
                dispatch(
                    openAlert(t("messages.trashMsgs.success", { entity: t("labels.folder") }), statusTypesData.success),
                );
            })
            ["catch"]((err) => {
                displayErrorHandler(
                    err.response.data.message === constantsData.networkError
                        ? t("messages.networkFailure")
                        : err.response.data.message,
                    dispatch,
                    openAlert,
                    err.response.status,
                    logout,
                );
            })
            ["finally"](() => {
                toast.dismiss(`${trashDriveManagementFolderPendingToastName}_${toastId}`);

                setLoading(false);

                dispatch(setRefetchDriveManagementList(true));
            });
    };

    useEffect(
        () => {
            if (loading) {
                toast.info(() => t("messages.trashMsgs.pending", { entity: t("labels.folder") }), {
                    toastId: `${trashDriveManagementFolderPendingToastName}_${toastId}`,
                });
            }
        },
        [loading], //eslint-disable-line
    );

    return {
        loading,
        trashDriveManagementFolder,
    };
};

export default useTrashDriveManagementFolder;
